export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10401.4515d525.jpg";